import Loader from './Loader';
import LoaderComponent from './Loader.Component';

export  {LoaderComponent};
export default Loader;

